import React, { Dispatch, SetStateAction, useMemo } from 'react';
import { Icon, IconsEnum } from 'components/Icons';
import styles from './ScommesseTableStatsTrigger.module.scss';

export type ScommesseTableStatsTriggerProps = {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  className?: string;
};

export const ScommesseTableStatsTrigger = ({ setIsOpen, className }: ScommesseTableStatsTriggerProps) => {
  const objIcon = useMemo(() => {
    return <Icon iconId={IconsEnum.STATS} className={styles.icon} color="var(--color-on-bg-secondary)" />;
  }, []);

  return (
    <button
      className={`${styles.button} ${className ? className : ''}`}
      onClick={() => {
        setIsOpen(true);
      }}
    >
      {objIcon}
    </button>
  );
};